import { UpdateUpdaterDialog } from './../../dialogs/update.updater/update.updater.dialog';
import { UpdaterVersionItemArray } from './../../models/domain/updater.version.item';
import { WindowService } from '../../services/window-dialogs/window.service';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SortBot } from '../../helpers/sort';
import { LiveHubService } from '@services/livehub.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

@Component({
    selector: 'update-updater',
    templateUrl: './update.updater.component.html',
    styleUrls: ['./update.updater.component.scss']
})

export class UpdateUpdaterComponent implements OnInit {
    IsBusy: boolean = false;

    UpdaterVersions: UpdaterVersionItemArray;

    VersionFilter: string = '';

    constructor(private liveHub: LiveHubService, private dialogService: DialogService, private gb: GlobalService, private api: ssApiService, private windowService: WindowService, private sweetAlertService: SweetAlertService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Updater Versions');
        // this.IsBusy = true;
        this.LoadUpdaterVersions();
    }

    LoadUpdaterVersions() {
        this.IsBusy = true;
        let disposable = this.api.GetUpdaterVersions().subscribe(response => {
            this.IsBusy = false;
            this.UpdaterVersions = response.Data;
            disposable.unsubscribe();
        });
    }

    AddVersion() {
        let disposable = this.dialogService.addDialog(UpdateUpdaterDialog, {
            Title: 'Add Version'
        }, { width: 600, height: 500 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadUpdaterVersions();
            }
        });
    }

    PushNewestUpdate() {
        this.liveHub.InvokeConnection('PushNewestUpdate');

        this.liveHub.PushNewestUpdateResponse.subscribe(response => {
            if (response) {
                this.sweetAlertService.swal({
                    type: 'success',
                    title: 'Update Pushed Successfully',
                    text: 'All connected livehub clients will be instructed to contact our servers for an update'
                }).then( () => {}, () => {} );
            }
        });        
    }

    EditVersion(version) {
        let disposable = this.dialogService.addDialog(UpdateUpdaterDialog, {
            Title: 'Edit Version',
            Version: version
        }, { width: 600, height: 500 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadUpdaterVersions();
            }
        });
    }

    SortBy( sortVar1: string, sortVar2: string = '' ) {
        this.UpdaterVersions = SortBot.SortAuto( this.UpdaterVersions, sortVar1, sortVar2);
    }

    onSearchTable(term) {
        this.VersionFilter = term;
    }

}
